// Updated CreateAbha.js with step persistence using localStorage
import React, { useEffect, useState } from "react";
import { useOutletContext, useLocation } from "react-router-dom";
import CountUp from "react-countup";

import MobileVerify from "../Mobile-verify/mobile-verify";
import MobileOtp from "../Mobile-otp/mobile-otp";
import Patient from "../Patient/patient";
import ConfirmDetail from "../Confirm-detail/confirm-details";
import AdharNumber from "../Adhar-number/adhar-number";
import AdhaOtp from "../Adhar-otp/adhar-otp";
import AbhaAddress from "../Abha-address/abha-address";
import AbhaCard from "../Abha-card/abha-card";
import AadharCard from "../aadhar-card/aadhar-card";
import MobileVerifyOtp from "../Mobile-verify-otp/mobile-verify-otp";
import FAQSection from "../../components/FAQSection";
import lab from "../../assets/image/lab.png";
import about from "../../assets/image/nha-logo.png";
import benefits from "../../assets/image/benefits.png";
import benefits2 from "../../assets/image/benefits2.png";
import benefits3 from "../../assets/image/benefits3.png";
import benefits4 from "../../assets/image/benefits4.png";
import benefits5 from "../../assets/image/benefits5.png";
import benefits6 from "../../assets/image/benefits6.png";
import googleplay from "../../assets/image/google-play.png";
import appstore from "../../assets/image/app-stor.png";
import { setAbhaLoader } from "../../redux/slices/abhaSlice";
import { useSelector } from "react-redux";
import MobileVerification from "../Adhar-otp/mobile-verification";
import { current } from "@reduxjs/toolkit";
import LoginMobileOTP from "../Mobile-verify/mobile-verify";
import LoginMobileOTPSend from "../Mobile-verify/mobile-verify";
import LoginMobileOtpVerify from "../Mobile-otp/mobile-otp";
import PatientList from "../Patient/patient";
import ConfirmPatientDetail from "../Confirm-detail/confirm-details";
import SendAdharOTP from "../Adhar-number/adhar-number";
import VerifyAdhaOtp from "../Adhar-otp/adhar-otp";
import MobileVerificationOTPSend from "../Adhar-otp/mobile-verification";
import MobileVerificationOTPVerify from "../Mobile-verify-otp/mobile-verify-otp";
import AbhaSuggestions from "../Abha-address/abha-address";
import PerferredAbhaOptions from "../Adhar-otp/PerferredAbhaOptions";
import MobileUpdateOTPSend from "../change-mobile";
import MobileVerificationOTPVerifyToUpdateContact from "../change-mobile/verification-screen";
import HealthRecordsSection from "../../components/HealthRecordsSection";
import StatisticsSection from "../../components/StatisticsSection";

const CreatAbha = ({ onNavigate }) => {
  const [sendOtpFunction, setSendOtpFunction] = useState(() => () => {});
  const [mobileOTPSent, setMobileOTPSent] = useState(false);
  const [isMobileVerified, setIsMobileVerified] = useState(false);
  const [currentStep, setCurrentStep] = useState("LoginMobileOTPSend");
  const [isVerifiedotp, setIsVerifiedOtp] = useState(false);
  const [isPatient, setPatient] = useState(false);
  const [isconfirm, setIsconfirm] = useState(false);
  const [isAdharNumber, setAdharNumber] = useState(false);
  const [isAdharOtp, setAdharOtp] = useState(false);
  const [mobileVerificationOTPSent, setMobileVerificationOTPSent] =
    useState(false);
  const [isAdhaaddress, setAdhaaddress] = useState(false);
  const [isVerifiedMobileOTP, setMobileverifyOtp] = useState(false);
  const handleClick = () => {
    formRef.current?.scrollIntoView({ behavior: "smooth" });
  };
  const { formRef, userData } = useOutletContext();
  const location = useLocation();

  // Check if URL contains patientId and mobile query parameters
  const searchParams = new URLSearchParams(location.search);
  const hasPatientParams = searchParams.has("patientID") && searchParams.has("mobileNumber");

  const loader = useSelector((state) => state.user.loading);

  console.log("isVerified", isAdharNumber);

  const globalCurrentStepp = useSelector(
    (state) => state.user.globalCurrentStep
  );

  const stepOrder = [
    "LoginMobileOTPSend",
    "LoginMobileOtpVerify",
    "PatientList",
    "ConfirmPatientDetail",
    "SendAdharOTP",
    "VerifyAdhaOtp",
    "MobileVerificationOTPSend",
    "MobileVerificationOTPVerify",
    "AbhaSuggestions",
    "AbhaCard",
  ];

  useEffect(() => {
    if (userData && Object.keys(userData).length > 0) {
      setCurrentStep("ConfirmPatientDetail");
    }
  }, [userData]);

  // Save patient data to localStorage when coming from query params
  useEffect(() => {
    if (userData && userData.patientId && userData.mobile) {
      const patientData = {
        _id: userData.patientId,
        phone_number: userData.mobile,
        patient_unique_id: userData.patientId, // Using patientId as unique ID
        patient_type: 0,
        name: "Patient", // Default name since we don't have full details
        first_name: "Patient",
        last_name: "",
        relation_type: "self",
        // Add other default fields as needed
      };
      localStorage.setItem("selectedIndex", JSON.stringify(patientData));
    }
  }, [userData]);

  const handleBack = () => {
    const currentIndex = stepOrder.indexOf(currentStep);
    if (currentIndex > 0) {
      const prevStep = stepOrder[currentIndex - 1];
      setCurrentStep(prevStep);
    }
  };
  useEffect(() => {
    if (globalCurrentStepp) {
      setCurrentStep(globalCurrentStepp);
    }
  }, [globalCurrentStepp]);
  // const handleBack = () => {
  //   console.log("object");
  //   if (isAdhaaddress) setAdhaaddress(false);
  //   else if (isVerifiedMobileOTP) setMobileverifyOtp(false);
  //   else if (isAdharOtp) setAdharOtp(false);
  //   else if (isAdharNumber) setAdharNumber(false);
  //   else if (isconfirm) setIsconfirm(false);
  //   else if (isPatient) setPatient(false);
  //   else if (isVerifiedotp) setIsVerifiedOtp(false);
  //   else if (isMobileVerified) setIsMobileVerified(false);
  // };

  return (
    <>
      {loader && (
        <div
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            width: "100vw",
            height: "100vh",
            backgroundColor: "rgba(255, 255, 255, 0.7)",
            zIndex: 9999,
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            pointerEvents: "all",
          }}
        >
          {" "}
        </div>
      )}
      {currentStep === "LoginMobileOTPSend" && (
        <div ref={formRef}>
          <LoginMobileOTPSend
            setIsMobileVerified1={setIsMobileVerified}
            setMobileOTPSent={setMobileOTPSent}
            setIsVerifiedOtp={setIsVerifiedOtp}
            setCurrentStep={setCurrentStep}
          />
        </div>
      )}

      {currentStep === "LoginMobileOtpVerify" && (
        <div ref={formRef}>
          <LoginMobileOtpVerify
            setIsVerifiedOtp={setIsVerifiedOtp}
            setMobileOTPSent={setMobileOTPSent}
            setCurrentStep={setCurrentStep}
          />
        </div>
      )}

      {currentStep === "PatientList" && (
        <div ref={formRef}>
          <PatientList
            isVerifiedotp={isVerifiedotp}
            setPatient={setPatient}
            setCurrentStep={setCurrentStep}
          />
        </div>
      )}
      {currentStep === "ConfirmPatientDetail" && (
        <div ref={formRef}>
          <ConfirmPatientDetail
            userData={userData}
            isPatient={isPatient}
            setIsconfirm={setIsconfirm}
            handleBack={handleBack}
            setPatient={setPatient}
            setCurrentStep={setCurrentStep}
          />
        </div>
      )}
      {(currentStep === "SendAdharOTP" ||
        currentStep === "AlreadyAbhaNumber") && (
        <div ref={formRef}>
          <SendAdharOTP
            isconfirm={isconfirm}
            setAdharNumber={setAdharNumber}
            setPatient1={setPatient}
            setCurrentStep={setCurrentStep}
          />
        </div>
      )}

      {currentStep === "VerifyAdhaOtp" && (
        <div ref={formRef}>
          <VerifyAdhaOtp
            isAdharNumber={isAdharNumber}
            setAdharNumber={setAdharNumber}
            setAdharOtp={setAdharOtp}
            setIsConfirm1={setIsconfirm}
            setSendOtpFunction={setSendOtpFunction}
            sendOtpFunction={sendOtpFunction}
            setMobileverifyOtp={setMobileverifyOtp}
            setCurrentStep={setCurrentStep}
          />
        </div>
      )}
      {currentStep === "MobileVerificationOTPSend" && (
        <div ref={formRef}>
          <MobileVerificationOTPSend
            setMobileverifyOtp={setMobileverifyOtp}
            setAdharNumber={setAdharNumber}
            setAdharOtp={setAdharOtp}
            setMobileVerificationOTPSent1={setMobileVerificationOTPSent}
            setCurrentStep={setCurrentStep}
          />
        </div>
      )}
      {currentStep === "changeMobile" && (
        <div ref={formRef}>
          <MobileUpdateOTPSend
            setMobileverifyOtp={setMobileverifyOtp}
            setAdharNumber={setAdharNumber}
            setAdharOtp={setAdharOtp}
            setMobileVerificationOTPSent1={setMobileVerificationOTPSent}
            setCurrentStep={setCurrentStep}
          />
        </div>
      )}
      {currentStep === "MobileVerificationOTPVerify" && (
        <div ref={formRef}>
          <MobileVerificationOTPVerify
            isAdharOtp={isAdharOtp}
            setMobileverifyOtp={setMobileverifyOtp}
            setMobileVerificationOTPSent1={setMobileVerificationOTPSent}
            setIsconfirm={setIsconfirm}
            setCurrentStep={setCurrentStep}
          />
        </div>
      )}
      {currentStep === "MobileVerificationOTPVerifyToUpdateContact" && (
        <div ref={formRef}>
          <MobileVerificationOTPVerifyToUpdateContact
            isAdharOtp={isAdharOtp}
            setMobileverifyOtp={setMobileverifyOtp}
            setMobileVerificationOTPSent1={setMobileVerificationOTPSent}
            setIsconfirm={setIsconfirm}
            setCurrentStep={setCurrentStep}
          />
        </div>
      )}
      {currentStep === "PerferredAbhaOptions" && (
        <div ref={formRef}>
          <PerferredAbhaOptions setCurrentStep={setCurrentStep} />
        </div>
      )}
      {currentStep === "AbhaSuggestions" && (
        <div ref={formRef}>
          <AbhaSuggestions
            isVerifiedMobileOTP={isVerifiedMobileOTP}
            setAdhaaddress={setAdhaaddress}
            setMobileVerificationOTPSent1={setMobileVerificationOTPSent}
            setCurrentStep={setCurrentStep}
          />
        </div>
      )}
      {currentStep === "AbhaCard" && (
        <div ref={formRef}>
          <AbhaCard
            isAdhaaddress={isAdhaaddress}
            setCurrentStep={setCurrentStep}
          />
        </div>
      )}

      {/* ######################################################## */}
      {/* {!mobileOTPSent && !isMobileVerified && (
        <div ref={formRef}>
          <MobileOtp
            setIsVerifiedOtp={setIsVerifiedOtp}
            setMobileOTPSent={setMobileOTPSent}
          />
        </div>
      )}
      {mobileOTPSent && (
        <div ref={formRef}>
          <MobileVerify
            setIsMobileVerified1={setIsMobileVerified}
            setMobileOTPSent={setMobileOTPSent}
            setIsVerifiedOtp={setIsVerifiedOtp}
          />
        </div>
      )}

      {isVerifiedotp && (
        <div ref={formRef}>
          <Patient isVerifiedotp={isVerifiedotp} setPatient={setPatient} />
        </div>
      )}
      {isPatient && !isconfirm && (
        <div ref={formRef}>
          <ConfirmDetail
            isPatient={isPatient}
            setIsconfirm={setIsconfirm}
            handleBack={handleBack}
            setPatient={setPatient}
          />
        </div>
      )}
      {isconfirm && !isAdharNumber && (
        <div ref={formRef}>
          <AdharNumber
            isconfirm={isconfirm}
            setAdharNumber={setAdharNumber}
            setPatient1={setPatient}
          />
        </div>
      )}
      {isAdharNumber && !isAdharOtp && (
        <div ref={formRef}>
          <AdhaOtp
            isAdharNumber={isAdharNumber}
            setAdharNumber={setAdharNumber}
            setAdharOtp={setAdharOtp}
            setIsConfirm1={setIsconfirm}
            setSendOtpFunction={setSendOtpFunction}
            sendOtpFunction={sendOtpFunction}
            setMobileverifyOtp={setMobileverifyOtp}
          />
        </div>
      )}
      {isAdharOtp && (
        <div ref={formRef}>
          <MobileVerification
            setMobileverifyOtp={setMobileverifyOtp}
            setAdharNumber={setAdharNumber}
            setAdharOtp={setAdharOtp}
            setMobileVerificationOTPSent1={setMobileVerificationOTPSent}
          />
        </div>
      )}
      {mobileVerificationOTPSent && (
        <div ref={formRef}>
          <MobileVerifyOtp
            isAdharOtp={isAdharOtp}
            setMobileverifyOtp={setMobileverifyOtp}
            setMobileVerificationOTPSent1={setMobileVerificationOTPSent}
            setIsconfirm={setIsconfirm}
          />
        </div>
      )}
      {isVerifiedMobileOTP && !isAdhaaddress && (
        <div ref={formRef}>
          <AbhaAddress
            isVerifiedMobileOTP={isVerifiedMobileOTP}
            setAdhaaddress={setAdhaaddress}
            setMobileVerificationOTPSent1={setMobileVerificationOTPSent}
          />
        </div>
      )}
      {isAdhaaddress ? (
        <div ref={formRef}>
          <AbhaCard isAdhaaddress={isAdhaaddress} />
        </div>
      ) : (
        ""
      )} */}

      {/* ##################################### */}

      {/* {step === "mobile-verify" && (
        <div ref={formRef}>
          <MobileVerify setIsVerified={() => goToNextStep("mobile-otp")} />
        </div>
      )}
      {step === "mobile-otp" && (
        <div ref={formRef}>
          <MobileOtp setIsVerifiedOtp={() => goToNextStep("patient")} />
        </div>
      )}
      {step === "patient" && (
        <div ref={formRef}>
          <Patient setPatient={() => goToNextStep("confirm-detail")} />
        </div>
      )}
      {step === "confirm-detail" && (
        <div ref={formRef}>
          <ConfirmDetail setIsconfirm={() => goToNextStep("adhar-number")} />
        </div>
      )}
      {step === "adhar-number" && (
        <div ref={formRef}>
          <AdharNumber
            setAdharNumber={() => goToNextStep("adhar-otp")}
            setSendOtpFunction={setSendOtpFunction}
            setAdharNumbers={setAdharNumbers}
          />
        </div>
      )}
      {step === "adhar-otp" && (
        <div ref={formRef}>
          <AdhaOtp
            setAdharOtp={() => goToNextStep("mobile-verify-otp")}
            sendOtpFunction={sendOtpFunction}
          />
        </div>
      )}
      {step === "mobile-verify-otp" && (
        <div ref={formRef}>
          <MobileVerifyOtp
            setMobileverifyOtp={() => goToNextStep("aadhar-card")}
          />
        </div>
      )}
      {step === "aadhar-card" && (
        <div ref={formRef}>
          <AadharCard setAadharcart={() => goToNextStep("abha-address")} />
        </div>
      )}
      {step === "abha-address" && (
        <div ref={formRef}>
          <AbhaAddress setAdhaaddress={() => goToNextStep("done")} />
        </div>
      )}
      {step === "done" && (
        <div ref={formRef}>
          <AbhaCard setIsVerifiedMobile={() => goToNextStep("mobile-verify")} />
        </div> */}
      {/* )} */}

      {/* Stats Section */}
      {/* <div className="banner-third-bg">
        <section className="container">
          <div className="col-md-12">
            <div className="row">
              <div className="col-ms-3 col-lg-3">
                <div className="stats-item1">
                  <b>
                    <CountUp end={700} duration={5} separator="," />
                    M+
                  </b>
                  <p>Ayushman Bharat Health Accounts (ABHA)</p>
                </div>
              </div>
              <div className="col-ms-3 col-lg-3">
                <div className="stats-item2">
                  <b>
                    <CountUp end={600} duration={5} separator="," />
                    M+
                  </b>
                  <p>Health Records Linked</p>
                </div>
              </div>
              <div className="col-ms-3 col-lg-3">
                <div className="stats-item3">
                  <b>
                    <CountUp end={400} duration={5} separator="," />
                    K+
                  </b>
                  <p>Verified Facilities on HFR</p>
                </div>
              </div>
              <div className="col-ms-3 col-lg-3">
                <div className="stats-item4">
                  <b>
                    <CountUp end={600} duration={5} separator="," />
                    K+
                  </b>
                  <p>Verified Healthcare Professionals</p>
                </div>
              </div>
            </div>
          </div>
        </section>
      </div> */}

      {/* Info and Benefits Section */}
      {/* <section className="banner-forth-bg abha-info-section">
        <div className="bg-color">
          <div className="row">
            <div className="col-ms-1 col-lg-1"></div>
            <div className="col-ms-5 col-lg-5">
              <div className="header-logos">
                <p>APPROVED BY NHA</p>
                <img src={about} alt="NHA Logo" className="nha-logo" />
                <img
                  src={lab}
                  alt="Lal Path Labs Approved"
                  className="approved-logo approved-logo-nha"
                />
              </div>
              <div className="pathkind-lab">
                <h3>Create Lal Path Labs (Health ID)</h3>
              </div>
              <p className="abha-description">
                Be part of Ayushman Bharat Digital Mission (ABDM) and start your
                <br /> digital health journey
              </p>
              <button className="lik-abha-button" onClick={handleClick}>
                Create/Link Abha
              </button>
              <div className="app-links">
                <a
                  href="https://apps.apple.com/in/app/dr-lal-pathlabs/id1111250276"
                  target="_blank"
                  className="text-black"
                  rel="noreferrer"
                >
                  <img src={appstore} alt="App Store" />
                </a>
                <a
                  href="https://play.google.com/store/apps/details?id=pathlabs.com.pathlabs&hl=en_IN&gl=US&pli=1"
                  target="_blank"
                  className="text-black"
                  rel="noreferrer"
                >
                  <img src={googleplay} alt="Google Play" />
                </a>
              </div>
            </div>
          </div>
        </div>
      </section> */}
      {!hasPatientParams && <StatisticsSection />}
      {!hasPatientParams && <HealthRecordsSection />}
      {!hasPatientParams && <section className="abha-steps-section">
        <div className="container">
          <div className="heading-section">
            <h2>Benefits of ABHA HEALTH card</h2>
            <p>
              Creating ABHA card is the first step towards making digital health
              records safer and more
              <br /> efficient for you and your family.
            </p>
          </div>

          <div className="row">
            {[
              benefits,
              benefits2,
              benefits3,
              benefits4,
              benefits5,
              benefits6,
            ].map((img, index) => (
              <div key={index} className="col-ms-6 col-lg-4">
                <div className="card-item">
                  <div className="benefit-item">
                    <div className="benefit-icons">
                      <img
                        src={img}
                        alt={`Benefit ${index + 1}`}
                        className="benefit-icon"
                      />
                      <h4>
                        {
                          [
                            "Digital Health Records",
                            "Personal Health Records (PHR)",
                            "Consent Based Access",
                            "Secure and Private",
                            "Voluntary Opt-In",
                            "Access to Doctors Digitally",
                          ][index]
                        }
                      </h4>
                    </div>
                  </div>
                  <p>
                    {
                      [
                        "All your health information at your fingertips.",
                        "Connect and integrate your individual health records using ABHA to build a comprehensive health history over time.",
                        "Your health data will only be accessed with your clear and informed consent.",
                        "Designed with robust security and encryption mechanisms, and no information is shared without your permission.",
                        "It is not mandatory to carry the ABHA Address card. If you wish to opt-out and request to erase your data at any time, you may do so",
                        "By registering for an ABHA Address, you will have access to doctors online securely and safely.",
                      ][index]
                    }
                  </p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>}
      {!hasPatientParams && <FAQSection />}
      {!hasPatientParams && (
        <div class="container my-4">
          <div class="row">
            <div class="col-12">
              <h6 class="mb-3 fw-bold">Lab Test At Home</h6>
            <ul class="list-inline">
              <li class="list-inline-item">
                <a
                  href="https://www.lalpathlabs.com/book-a-test/agartala"
                  target="_blank"
                  className="links"
                >
                  Agartala
                </a>
              </li>
              |&nbsp;
              <li class="list-inline-item">
                <a
                  href="https://www.lalpathlabs.com/book-a-test/agra"
                  target="_blank"
                  className="links"
                >
                  Agra
                </a>
              </li>
              |&nbsp;
              <li class="list-inline-item">
                <a
                  href="https://www.lalpathlabs.com/book-a-test/ahmedabad"
                  target="_blank"
                  className="links"
                >
                  Ahmedabad
                </a>
              </li>
              |&nbsp;
              <li class="list-inline-item">
                <a
                  href="https://www.lalpathlabs.com/book-a-test/aligarh"
                  target="_blank"
                  className="links"
                >
                  Aligarh
                </a>
              </li>
              |&nbsp;
              <li class="list-inline-item">
                <a
                  href="https://www.lalpathlabs.com/book-a-test/allahabad"
                  target="_blank"
                  className="links"
                >
                  Allahabad
                </a>
              </li>
              |&nbsp;
              <li class="list-inline-item">
                <a
                  href="https://www.lalpathlabs.com/book-a-test/alwar"
                  target="_blank"
                  className="links"
                >
                  Alwar
                </a>
              </li>
              |&nbsp;
              <li class="list-inline-item">
                <a
                  href="https://www.lalpathlabs.com/book-a-test/ambala"
                  target="_blank"
                  className="links"
                >
                  Ambala
                </a>
              </li>
              |&nbsp;
              <li class="list-inline-item">
                <a
                  href="https://www.lalpathlabs.com/book-a-test/amravati"
                  target="_blank"
                  className="links"
                >
                  Amravati
                </a>
              </li>
              |&nbsp;
              <li class="list-inline-item">
                <a
                  href="https://www.lalpathlabs.com/book-a-test/amritsar"
                  target="_blank"
                  className="links"
                >
                  Amritsar
                </a>
              </li>
              |&nbsp;
              <li class="list-inline-item">
                <a
                  href="https://www.lalpathlabs.com/book-a-test/aurangabad"
                  target="_blank"
                  className="links"
                >
                  Aurangabad
                </a>
              </li>
              |&nbsp;
              <li class="list-inline-item">
                <a
                  href="https://www.lalpathlabs.com/book-a-test/azamgarh"
                  target="_blank"
                  className="links"
                >
                  Azamgarh
                </a>
              </li>
              |&nbsp;
              <li class="list-inline-item">
                <a
                  href="https://www.lalpathlabs.com/book-a-test/bahadurgarh"
                  target="_blank"
                  className="links"
                >
                  Bahadurgarh
                </a>
              </li>
              |&nbsp;
              <li class="list-inline-item">
                <a
                  href="https://www.lalpathlabs.com/book-a-test/bareilly"
                  target="_blank"
                  className="links"
                >
                  Bareilly
                </a>
              </li>
              |&nbsp;
              <li class="list-inline-item">
                <a
                  href="https://www.lalpathlabs.com/book-a-test/begusarai"
                  target="_blank"
                  className="links"
                >
                  Begusarai
                </a>
              </li>
              |&nbsp;
              <li class="list-inline-item">
                <a
                  href="https://www.lalpathlabs.com/book-a-test/bengaluru"
                  target="_blank"
                  className="links"
                >
                  Bengaluru
                </a>
              </li>
              |&nbsp;
              <li class="list-inline-item">
                <a
                  href="https://www.lalpathlabs.com/book-a-test/bhatinda"
                  target="_blank"
                  className="links"
                >
                  Bhatinda
                </a>
              </li>
              |&nbsp;
              <li class="list-inline-item">
                <a
                  href="https://www.lalpathlabs.com/book-a-test/bhilai"
                  target="_blank"
                  className="links"
                >
                  Bhilai
                </a>
              </li>
              |&nbsp;
              <li class="list-inline-item">
                <a
                  href="https://www.lalpathlabs.com/book-a-test/bhopal"
                  target="_blank"
                  className="links"
                >
                  Bhopal
                </a>
              </li>
              |&nbsp;
              <li class="list-inline-item">
                <a
                  href="https://www.lalpathlabs.com/book-a-test/bhubaneshwar"
                  target="_blank"
                  className="links"
                >
                  Bhubaneshwar
                </a>
              </li>
              |&nbsp;
              <li class="list-inline-item">
                <a
                  href="https://www.lalpathlabs.com/book-a-test/bijnor"
                  target="_blank"
                  className="links"
                >
                  Bijnor
                </a>
              </li>
              |&nbsp;
              <li class="list-inline-item">
                <a
                  href="https://www.lalpathlabs.com/book-a-test/bilaspur"
                  target="_blank"
                  className="links"
                >
                  Bilaspur
                </a>
              </li>
              |&nbsp;
              <li class="list-inline-item">
                <a
                  href="https://www.lalpathlabs.com/book-a-test/chandigarh"
                  target="_blank"
                  className="links"
                >
                  Chandigarh
                </a>
              </li>
              |&nbsp;
              <li class="list-inline-item">
                <a
                  href="https://www.lalpathlabs.com/book-a-test/chennai"
                  target="_blank"
                  className="links"
                >
                  Chennai
                </a>
              </li>
              |&nbsp;
              <li class="list-inline-item">
                <a
                  href="https://www.lalpathlabs.com/book-a-test/coimbatore"
                  target="_blank"
                  className="links"
                >
                  Coimbatore
                </a>
              </li>
              |&nbsp;
              <li class="list-inline-item">
                <a
                  href="https://www.lalpathlabs.com/book-a-test/daltonganj"
                  target="_blank"
                  className="links"
                >
                  Daltonganj
                </a>
              </li>
              |&nbsp;
              <li class="list-inline-item">
                <a
                  href="https://www.lalpathlabs.com/book-a-test/darbhanga"
                  target="_blank"
                  className="links"
                >
                  Darbhanga
                </a>
              </li>
              |&nbsp;
              <li class="list-inline-item">
                <a
                  href="https://www.lalpathlabs.com/book-a-test/dehradun"
                  target="_blank"
                  className="links"
                >
                  Dehradun
                </a>
              </li>
              |&nbsp;
              <li class="list-inline-item">
                <a
                  href="https://www.lalpathlabs.com/book-a-test/delhi"
                  target="_blank"
                  className="links"
                >
                  Delhi
                </a>
              </li>
              |&nbsp;
              <li class="list-inline-item">
                <a
                  href="https://www.lalpathlabs.com/book-a-test/deoria"
                  target="_blank"
                  className="links"
                >
                  Deoria
                </a>
              </li>
              |&nbsp;
              <li class="list-inline-item">
                <a
                  href="https://www.lalpathlabs.com/book-a-test/dhanbad"
                  target="_blank"
                  className="links"
                >
                  Dhanbad
                </a>
              </li>
              |&nbsp;
              <li class="list-inline-item">
                <a
                  href="https://www.lalpathlabs.com/book-a-test/durgapur"
                  target="_blank"
                  className="links"
                >
                  Durgapur
                </a>
              </li>
              |&nbsp;
              <li class="list-inline-item">
                <a
                  href="https://www.lalpathlabs.com/book-a-test/faridabad"
                  target="_blank"
                  className="links"
                >
                  Faridabad
                </a>
              </li>
              |&nbsp;
              <li class="list-inline-item">
                <a
                  href="https://www.lalpathlabs.com/book-a-test/faizabad"
                  target="_blank"
                  className="links"
                >
                  Faizabad
                </a>
              </li>
              |&nbsp;
              <li class="list-inline-item">
                <a
                  href="https://www.lalpathlabs.com/book-a-test/gaya"
                  target="_blank"
                  className="links"
                >
                  Gaya
                </a>
              </li>
              |&nbsp;
              <li class="list-inline-item">
                <a
                  href="https://www.lalpathlabs.com/book-a-test/ghaziabad"
                  target="_blank"
                  className="links"
                >
                  Ghaziabad
                </a>
              </li>
              |&nbsp;
              <li class="list-inline-item">
                <a
                  href="https://www.lalpathlabs.com/book-a-test/goa%20velha"
                  target="_blank"
                  className="links"
                >
                  Goa Velha
                </a>
              </li>
              |&nbsp;
              <li class="list-inline-item">
                <a
                  href="https://www.lalpathlabs.com/book-a-test/gorakhpur"
                  target="_blank"
                  className="links"
                >
                  Gorakhpur
                </a>
              </li>
              |&nbsp;
              <li class="list-inline-item">
                <a
                  href="https://www.lalpathlabs.com/book-a-test/greater%20noida"
                  target="_blank"
                  className="links"
                >
                  Greater Noida
                </a>
              </li>
              |&nbsp;
              <li class="list-inline-item">
                <a
                  href="https://www.lalpathlabs.com/book-a-test/gurgaon"
                  target="_blank"
                  className="links"
                >
                  Gurgaon
                </a>
              </li>
              |&nbsp;
              <li class="list-inline-item">
                <a
                  href="https://www.lalpathlabs.com/book-a-test/guwahati"
                  target="_blank"
                  className="links"
                >
                  Guwahati
                </a>
              </li>
              |&nbsp;
              <li class="list-inline-item">
                <a
                  href="https://www.lalpathlabs.com/book-a-test/gwalior"
                  target="_blank"
                  className="links"
                >
                  Gwalior
                </a>
              </li>
              |&nbsp;
              <li class="list-inline-item">
                <a
                  href="https://www.lalpathlabs.com/book-a-test/haldwani"
                  target="_blank"
                  className="links"
                >
                  Haldwani
                </a>
              </li>
              |&nbsp;
              <li class="list-inline-item">
                <a
                  href="https://www.lalpathlabs.com/book-a-test/haridwar"
                  target="_blank"
                  className="links"
                >
                  Haridwar
                </a>
              </li>
              |&nbsp;
              <li class="list-inline-item">
                <a
                  href="https://www.lalpathlabs.com/book-a-test/hisar"
                  target="_blank"
                  className="links"
                >
                  Hisar
                </a>
              </li>
              |&nbsp;
              <li class="list-inline-item">
                <a
                  href="https://www.lalpathlabs.com/book-a-test/hoshiarpur"
                  target="_blank"
                  className="links"
                >
                  Hoshiarpur
                </a>
              </li>
              |&nbsp;
              <li class="list-inline-item">
                <a
                  href="https://www.lalpathlabs.com/book-a-test/howrah"
                  target="_blank"
                  className="links"
                >
                  Howrah
                </a>
              </li>
              |&nbsp;
              <li class="list-inline-item">
                <a
                  href="https://www.lalpathlabs.com/book-a-test/hyderabad"
                  target="_blank"
                  className="links"
                >
                  Hyderabad
                </a>
              </li>
              |&nbsp;
              <li class="list-inline-item">
                <a
                  href="https://www.lalpathlabs.com/book-a-test/indore"
                  target="_blank"
                  className="links"
                >
                  Indore
                </a>
              </li>
              |&nbsp;
              <li class="list-inline-item">
                <a
                  href="https://www.lalpathlabs.com/book-a-test/jabalpur"
                  target="_blank"
                  className="links"
                >
                  Jabalpur
                </a>
              </li>
              |&nbsp;
              <li class="list-inline-item">
                <a
                  href="https://www.lalpathlabs.com/book-a-test/jaipur"
                  target="_blank"
                  className="links"
                >
                  Jaipur
                </a>
              </li>
              |&nbsp;
              <li class="list-inline-item">
                <a
                  href="https://www.lalpathlabs.com/book-a-test/jalandhar"
                  target="_blank"
                  className="links"
                >
                  Jalandhar
                </a>
              </li>
              |&nbsp;
              <li class="list-inline-item">
                <a
                  href="https://www.lalpathlabs.com/book-a-test/jammu"
                  target="_blank"
                  className="links"
                >
                  Jammu
                </a>
              </li>
              |&nbsp;
              <li class="list-inline-item">
                <a
                  href="https://www.lalpathlabs.com/book-a-test/jamshedpur"
                  target="_blank"
                  className="links"
                >
                  Jamshedpur
                </a>
              </li>
              |&nbsp;
              <li class="list-inline-item">
                <a
                  href="https://www.lalpathlabs.com/book-a-test/jodhpur"
                  target="_blank"
                  className="links"
                >
                  Jodhpur
                </a>
              </li>
              |&nbsp;
              <li class="list-inline-item">
                <a
                  href="https://www.lalpathlabs.com/book-a-test/kangra"
                  target="_blank"
                  className="links"
                >
                  Kangra
                </a>
              </li>
              |&nbsp;
              <li class="list-inline-item">
                <a
                  href="https://www.lalpathlabs.com/book-a-test/kanpur"
                  target="_blank"
                  className="links"
                >
                  Kanpur
                </a>
              </li>
              |&nbsp;
              <li class="list-inline-item">
                <a
                  href="https://www.lalpathlabs.com/book-a-test/karnal"
                  target="_blank"
                  className="links"
                >
                  Karnal
                </a>
              </li>
              |&nbsp;
              <li class="list-inline-item">
                <a
                  href="https://www.lalpathlabs.com/book-a-test/khanna"
                  target="_blank"
                  className="links"
                >
                  Khanna
                </a>
              </li>
              |&nbsp;
              <li class="list-inline-item">
                <a
                  href="https://www.lalpathlabs.com/book-a-test/kochi"
                  target="_blank"
                  className="links"
                >
                  Kochi
                </a>
              </li>
              |&nbsp;
              <li class="list-inline-item">
                <a
                  href="https://www.lalpathlabs.com/book-a-test/kolkata"
                  target="_blank"
                  className="links"
                >
                  Kolkata
                </a>
              </li>
              |&nbsp;
              <li class="list-inline-item">
                <a
                  href="https://www.lalpathlabs.com/book-a-test/kota"
                  target="_blank"
                  className="links"
                >
                  Kota
                </a>
              </li>
              |&nbsp;
              <li class="list-inline-item">
                <a
                  href="https://www.lalpathlabs.com/book-a-test/kurukshetra"
                  target="_blank"
                  className="links"
                >
                  Kurukshetra
                </a>
              </li>
              |&nbsp;
              <li class="list-inline-item">
                <a
                  href="https://www.lalpathlabs.com/book-a-test/lucknow"
                  target="_blank"
                  className="links"
                >
                  Lucknow
                </a>
              </li>
              |&nbsp;
              <li class="list-inline-item">
                <a
                  href="https://www.lalpathlabs.com/book-a-test/ludhiana"
                  target="_blank"
                  className="links"
                >
                  Ludhiana
                </a>
              </li>
              |&nbsp;
              <li class="list-inline-item">
                <a
                  href="https://www.lalpathlabs.com/book-a-test/mangalore"
                  target="_blank"
                  className="links"
                >
                  Mangalore
                </a>
              </li>
              |&nbsp;
              <li class="list-inline-item">
                <a
                  href="https://www.lalpathlabs.com/book-a-test/mathura"
                  target="_blank"
                  className="links"
                >
                  Mathura
                </a>
              </li>
              |&nbsp;
              <li class="list-inline-item">
                <a
                  href="https://www.lalpathlabs.com/book-a-test/meerut"
                  target="_blank"
                  className="links"
                >
                  Meerut
                </a>
              </li>
              |&nbsp;
              <li class="list-inline-item">
                <a
                  href="https://www.lalpathlabs.com/book-a-test/modinagar"
                  target="_blank"
                  className="links"
                >
                  Modinagar
                </a>
              </li>
              |&nbsp;
              <li class="list-inline-item">
                <a
                  href="https://www.lalpathlabs.com/book-a-test/moga"
                  target="_blank"
                  className="links"
                >
                  Moga
                </a>
              </li>
              |&nbsp;
              <li class="list-inline-item">
                <a
                  href="https://www.lalpathlabs.com/book-a-test/mohali"
                  target="_blank"
                  className="links"
                >
                  Mohali
                </a>
              </li>
              |&nbsp;
              <li class="list-inline-item">
                <a
                  href="https://www.lalpathlabs.com/book-a-test/moradabad"
                  target="_blank"
                  className="links"
                >
                  Moradabad
                </a>
              </li>
              |&nbsp;
              <li class="list-inline-item">
                <a
                  href="https://www.lalpathlabs.com/book-a-test/mumbai"
                  target="_blank"
                  className="links"
                >
                  Mumbai
                </a>
              </li>
              |&nbsp;
              <li class="list-inline-item">
                <a
                  href="https://www.lalpathlabs.com/book-a-test/muzaffarpur"
                  target="_blank"
                  className="links"
                >
                  Muzaffarpur
                </a>
              </li>
              |&nbsp;
              <li class="list-inline-item">
                <a
                  href="https://www.lalpathlabs.com/book-a-test/mysore"
                  target="_blank"
                  className="links"
                >
                  Mysore
                </a>
              </li>
              |&nbsp;
              <li class="list-inline-item">
                <a
                  href="https://www.lalpathlabs.com/book-a-test/nagpur"
                  target="_blank"
                  className="links"
                >
                  Nagpur
                </a>
              </li>
              |&nbsp;
              <li class="list-inline-item">
                <a
                  href="https://www.lalpathlabs.com/book-a-test/nashik"
                  target="_blank"
                  className="links"
                >
                  Nashik
                </a>
              </li>
              |&nbsp;
              <li class="list-inline-item">
                <a
                  href="https://www.lalpathlabs.com/book-a-test/noida"
                  target="_blank"
                  className="links"
                >
                  Noida
                </a>
              </li>
              |&nbsp;
              <li class="list-inline-item">
                <a
                  href="https://www.lalpathlabs.com/book-a-test/panchkula"
                  target="_blank"
                  className="links"
                >
                  Panchkula
                </a>
              </li>
              |&nbsp;
              <li class="list-inline-item">
                <a
                  href="https://www.lalpathlabs.com/book-a-test/panipat"
                  target="_blank"
                  className="links"
                >
                  Panipat
                </a>
              </li>
              |&nbsp;
              <li class="list-inline-item">
                <a
                  href="https://www.lalpathlabs.com/book-a-test/pathankot"
                  target="_blank"
                  className="links"
                >
                  Pathankot
                </a>
              </li>
              |&nbsp;
              <li class="list-inline-item">
                <a
                  href="https://www.lalpathlabs.com/book-a-test/patiala"
                  target="_blank"
                  className="links"
                >
                  Patiala
                </a>
              </li>
              |&nbsp;
              <li class="list-inline-item">
                <a
                  href="https://www.lalpathlabs.com/book-a-test/patna"
                  target="_blank"
                  className="links"
                >
                  Patna
                </a>
              </li>
              |&nbsp;
              <li class="list-inline-item">
                <a
                  href="https://www.lalpathlabs.com/book-a-test/pune"
                  target="_blank"
                  className="links"
                >
                  Pune
                </a>
              </li>
              |&nbsp;
              <li class="list-inline-item">
                <a
                  href="https://www.lalpathlabs.com/book-a-test/purnia"
                  target="_blank"
                  className="links"
                >
                  Purnia
                </a>
              </li>
              |&nbsp;
              <li class="list-inline-item">
                <a
                  href="https://www.lalpathlabs.com/book-a-test/raipur"
                  target="_blank"
                  className="links"
                >
                  Raipur
                </a>
              </li>
              |&nbsp;
              <li class="list-inline-item">
                <a
                  href="https://www.lalpathlabs.com/book-a-test/ranchi"
                  target="_blank"
                  className="links"
                >
                  Ranchi
                </a>
              </li>
              |&nbsp;
              <li class="list-inline-item">
                <a
                  href="https://www.lalpathlabs.com/book-a-test/rewari"
                  target="_blank"
                  className="links"
                >
                  Rewari
                </a>
              </li>
              |&nbsp;
              <li class="list-inline-item">
                <a
                  href="https://www.lalpathlabs.com/book-a-test/rohtak"
                  target="_blank"
                  className="links"
                >
                  Rohtak
                </a>
              </li>
              |&nbsp;
              <li class="list-inline-item">
                <a
                  href="https://www.lalpathlabs.com/book-a-test/sagar"
                  target="_blank"
                  className="links"
                >
                  Sagar
                </a>
              </li>
              |&nbsp;
              <li class="list-inline-item">
                <a
                  href="https://www.lalpathlabs.com/book-a-test/saharanpur"
                  target="_blank"
                  className="links"
                >
                  Saharanpur
                </a>
              </li>
              |&nbsp;
              <li class="list-inline-item">
                <a
                  href="https://www.lalpathlabs.com/book-a-test/shillong"
                  target="_blank"
                  className="links"
                >
                  Shillong
                </a>
              </li>
              |&nbsp;
              <li class="list-inline-item">
                <a
                  href="https://www.lalpathlabs.com/book-a-test/shimla"
                  target="_blank"
                  className="links"
                >
                  Shimla
                </a>
              </li>
              |&nbsp;
              <li class="list-inline-item">
                <a
                  href="https://www.lalpathlabs.com/book-a-test/silchar"
                  target="_blank"
                  className="links"
                >
                  Silchar
                </a>
              </li>
              |&nbsp;
              <li class="list-inline-item">
                <a
                  href="https://www.lalpathlabs.com/book-a-test/siliguri"
                  target="_blank"
                  className="links"
                >
                  Siliguri
                </a>
              </li>
              |&nbsp;
              <li class="list-inline-item">
                <a
                  href="https://www.lalpathlabs.com/book-a-test/sirsa"
                  target="_blank"
                  className="links"
                >
                  Sirsa
                </a>
              </li>
              |&nbsp;
              <li class="list-inline-item">
                <a
                  href="https://www.lalpathlabs.com/book-a-test/sonipat"
                  target="_blank"
                  className="links"
                >
                  Sonipat
                </a>
              </li>
              |&nbsp;
              <li class="list-inline-item">
                <a
                  href="https://www.lalpathlabs.com/book-a-test/srinagar"
                  target="_blank"
                  className="links"
                >
                  Srinagar
                </a>
              </li>
              |&nbsp;
              <li class="list-inline-item">
                <a
                  href="https://www.lalpathlabs.com/book-a-test/udaipur"
                  target="_blank"
                  className="links"
                >
                  Udaipur
                </a>
              </li>
              |&nbsp;
              <li class="list-inline-item">
                <a
                  href="https://www.lalpathlabs.com/book-a-test/vadodara"
                  target="_blank"
                  className="links"
                >
                  Vadodara
                </a>
              </li>
              |&nbsp;
              <li class="list-inline-item">
                <a
                  href="https://www.lalpathlabs.com/book-a-test/varanasi"
                  target="_blank"
                  className="links"
                >
                  Varanasi
                </a>
              </li>
              |&nbsp;
              <li class="list-inline-item">
                <a
                  href="https://www.lalpathlabs.com/book-a-test/yamuna%20nagar"
                  target="_blank"
                  className="links"
                >
                  Yamuna Nagar
                </a>
              </li>
            </ul>
          </div>
        </div>
      </div>
      )}
      {!hasPatientParams && (
        <div class="container my-4">
          <div class="row">
            <div class="col-12">
              <h6 class="mb-3 fw-bold">Popular Tests</h6>
            <ul class="list-inline">
              <li class="list-inline-item">
                <a
                  href="https://www.lalpathlabs.com/test-for-pregnancy"
                  target="_blank"
                  className="links"
                >
                  Pregnancy Test
                </a>
              </li>
              |&nbsp;
              <li class="list-inline-item">
                <a
                  href="https://www.lalpathlabs.com/swasth-fit-packages-full-body-checkups"
                  target="_blank"
                  className="links"
                >
                  Full Body Checkups
                </a>
              </li>
              |&nbsp;
              <li class="list-inline-item">
                <a
                  href="https://www.lalpathlabs.com/pathology-test/covid-19-qualitative-pcr"
                  target="_blank"
                  className="links"
                >
                  Covid 19 Test
                </a>
              </li>
              |&nbsp;
              <li class="list-inline-item">
                <a
                  href="https://www.lalpathlabs.com/test-for-heart-diseases"
                  target="_blank"
                  className="links"
                >
                  Heart Test
                </a>
              </li>
              |&nbsp;
              <li class="list-inline-item">
                <a
                  href="https://www.lalpathlabs.com/test-for-kidney"
                  target="_blank"
                  className="links"
                >
                  Kidney Test
                </a>
              </li>
              |&nbsp;
              <li class="list-inline-item">
                <a
                  href="https://www.lalpathlabs.com/test-for-liver"
                  target="_blank"
                  className="links"
                >
                  Liver Test
                </a>
              </li>
              |&nbsp;
              <li class="list-inline-item">
                <a
                  href="https://www.lalpathlabs.com/pathology-test/complete-blood-count"
                  target="_blank"
                  className="links"
                >
                  CBC Test
                </a>
              </li>
              |&nbsp;
              <li class="list-inline-item">
                <a
                  href="https://www.lalpathlabs.com/pathology-test/lipid-profile-complete"
                  target="_blank"
                  className="links"
                >
                  Cholesterol Test
                </a>
              </li>
              |&nbsp;
              <li class="list-inline-item">
                <a
                  href="https://www.lalpathlabs.com/pathology-test/hba1c"
                  target="_blank"
                  className="links"
                >
                  HbA1c Test
                </a>
              </li>
              |&nbsp;
              <li class="list-inline-item">
                <a
                  href="https://www.lalpathlabs.com/pathology-test/hepatitis-b-profile"
                  target="_blank"
                  className="links"
                >
                  Hepatitis B Test
                </a>
              </li>
              |&nbsp;
              <li class="list-inline-item">
                <a
                  href="https://www.lalpathlabs.com/test-for-kidney"
                  target="_blank"
                  className="links"
                >
                  Kidney Function Test
                </a>
              </li> |&nbsp;
              <li class="list-inline-item">
                <a
                  href="https://www.lalpathlabs.com/test-for-liver"
                  target="_blank"
                  className="links"
                >
                  Liver Function Test
                </a>
              </li>
              |&nbsp;
              <li class="list-inline-item">
                <a
                  href="https://www.lalpathlabs.com/pathology-test/sugar-advance"
                  target="_blank"
                  className="links"
                >
                  Sugar Test
                </a>
              </li> |&nbsp;
              <li class="list-inline-item">
                <a
                  href="https://www.lalpathlabs.com/test-for-thyroid-function"
                  target="_blank"
                  className="links"
                >
                  Thyroid Test
                </a>
              </li>
              |&nbsp;
              <li class="list-inline-item">
                <a
                  href="https://www.lalpathlabs.com/test-for-typhoid"
                  target="_blank"
                  className="links"
                >
                  Typhoid Test
                </a>
              </li>
              |&nbsp;
              <li class="list-inline-item">
                <a
                  href="https://www.lalpathlabs.com/pathology-test/uric-acid-serum"
                  target="_blank"
                  className="links"
                >
                  Uric Acid Test
                </a>
              </li> |&nbsp;
              <li class="list-inline-item">
                <a
                  href="https://www.lalpathlabs.com/test-for-vitamin-b12-deficiency"
                  target="_blank"
                  className="links"
                >
                  Vitamin B12 Test
                </a>
              </li>
              |&nbsp;
              <li class="list-inline-item">
                <a
                  href="https://www.lalpathlabs.com/vitamin-d"
                  target="_blank"
                  className="links"
                >
                  Vitamin D Test
                </a>
              </li>
              |&nbsp;
              <li class="list-inline-item">
                <a
                  href="https://www.lalpathlabs.com/test-for-allergy"
                  target="_blank"
                  className="links"
                >
                  Allergy Test
                </a>
              </li>
              |&nbsp;
              <li class="list-inline-item">
                <a
                  href="https://www.lalpathlabs.com/test-for-arthritis"
                  target="_blank"
                  className="links"
                >
                  Arthritis Test
                </a>
              </li>
              |&nbsp;
              <li class="list-inline-item">
                <a
                  href="https://www.lalpathlabs.com/test-for-cancer"
                  target="_blank"
                  className="links"
                >
                  Cancer Test
                </a>
              </li>
              |&nbsp;
              <li class="list-inline-item">
                <a
                  href="https://www.lalpathlabs.com/test-for-bone-&-mineral-metabolism"
                  target="_blank"
                  className="links"
                >
                  Bone And Joint
                </a>
              </li>
              |&nbsp;
              <li class="list-inline-item">
                <a
                  href="https://www.lalpathlabs.com/test-for-dengue"
                  target="_blank"
                  className="links"
                >
                  Dengue Test
                </a>
              </li>
              |&nbsp;
              <li class="list-inline-item">
                <a
                  href="https://www.lalpathlabs.com/test-for-diabetes"
                  target="_blank"
                  className="links"
                >
                  Diabetes Test
                </a>
              </li>
              |&nbsp;
              <li class="list-inline-item">
                <a
                  href="https://www.lalpathlabs.com/test-for-rheumatoid"
                  target="_blank"
                  className="links"
                >
                  Rheumatoid Test
                </a>
              </li>
              |&nbsp;
              <li class="list-inline-item">
                <a
                  href="https://www.lalpathlabs.com/test-for-tuberculosis"
                  target="_blank"
                  className="links"
                >
                  Tuberculosis Test
                </a>
              </li>
              |&nbsp;
              <li class="list-inline-item">
                <a
                  href="https://www.lalpathlabs.com/infertility"
                  target="_blank"
                  className="links"
                >
                  Infertility Test
                </a>
              </li>
              |&nbsp;
              <li class="list-inline-item">
                <a
                  href="https://www.lalpathlabs.com/diabetes-care-program"
                  target="_blank"
                  className="links"
                >
                  Diabetes Care
                </a>
              </li>
              |&nbsp;
              <li class="list-inline-item">
                <a
                  href="https://www.lalpathlabs.com/test-for-anemia"
                  target="_blank"
                  className="links"
                >
                  Anemia Test
                </a>
              </li>
              |&nbsp;
              <li class="list-inline-item">
                <a
                  href="https://www.lalpathlabs.com/test-for-gastrointestinal-infection"
                  target="_blank"
                  className="links"
                >
                  GastroIntestinal
                </a>
              </li>
              |&nbsp;
              <li class="list-inline-item">
                <a
                  href="https://www.lalpathlabs.com/test-for-autoimmune-disorders"
                  target="_blank"
                  className="links"
                >
                  Autoimmune Disorders
                </a>
              </li>
              |&nbsp;
              <li class="list-inline-item">
                <a
                  href="https://www.lalpathlabs.com/test-for-fever"
                  target="_blank"
                  className="links"
                >
                  Fever Test
                </a>
              </li>
            </ul>
          </div>
        </div>
      </div>
      )}
    </>
  );
};

export default CreatAbha;
